module.exports = __webpack_public_path__ + "img/6-kola-min.83817aea.png";